import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

export default function Legal() {
  const { t } = useI18n();
  return (
    <div className="min-h-[calc(100vh-64px)] bg-[#F4F4F4] text-black px-5 py-10" data-testid="legal-page">
      <div className="max-w-3xl mx-auto">
        <div className="font-mono-civic text-xs uppercase tracking-[0.3em] text-black">{t("legal_tag")}</div>
        <h1 className="mt-2 font-serif-display text-black leading-[0.9] text-5xl sm:text-6xl" style={{ fontWeight: 800 }}>
          {t("legal_h1")}
        </h1>

        <div className="mt-10 space-y-10 text-black" style={{ fontWeight: 700 }}>
          <section className="bg-white border-2 border-black brutal-shadow-sm p-6 sm:p-8">
            <h2 className="font-serif-display text-3xl mb-3" style={{ fontWeight: 800 }}>{t("legal_disclaimer_h")}</h2>
            <p>{t("legal_disclaimer_p1")}</p>
            <p className="mt-3">{t("legal_disclaimer_p2")}</p>
          </section>

          <section className="bg-white border-2 border-black brutal-shadow-sm p-6 sm:p-8">
            <h2 className="font-serif-display text-3xl mb-3" style={{ fontWeight: 800 }}>{t("legal_privacy_h")}</h2>
            <p>{t("legal_privacy_p1")}</p>
            <p className="mt-3">{t("legal_privacy_p2")}</p>
            <p className="mt-3">{t("legal_privacy_p3")}</p>
          </section>

          <section className="bg-white border-2 border-black brutal-shadow-sm p-6 sm:p-8">
            <h2 className="font-serif-display text-3xl mb-3" style={{ fontWeight: 800 }}>{t("legal_terms_h")}</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>{t("legal_terms_li1")}</li>
              <li>{t("legal_terms_li2")}</li>
              <li>{t("legal_terms_li3")}</li>
              <li>{t("legal_terms_li4")}</li>
              <li>{t("legal_terms_li5")}</li>
            </ul>
          </section>

          <section className="bg-white border-2 border-black brutal-shadow-sm p-6 sm:p-8">
            <h2 className="font-serif-display text-3xl mb-3" style={{ fontWeight: 800 }}>{t("legal_speech_h")}</h2>
            <p>{t("legal_speech_p")}</p>
          </section>

          <section data-testid="legal-platforms">
            <h2 className="font-serif-display text-3xl mb-3" style={{ fontWeight: 800 }}>{t("legal_platforms_h")}</h2>
            <p>{t("legal_platforms_p")}</p>
          </section>
        </div>

        <div className="mt-10">
          <Link to="/home" className="inline-block bg-black text-white uppercase tracking-widest px-6 py-4 border-2 border-black" style={{ fontWeight: 900 }} data-testid="legal-back-btn">
            {t("legal_back")}
          </Link>
        </div>
      </div>
    </div>
  );
}
